export default __webpack_public_path__ + "static/media/StartActivity.82b22b01.svg";